import { GetContactRequestModel } from './get-contact-request.model';

export class GetContactRequestMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GetContactRequestMessage!: GetContactRequestModel;
}
